import { watch as i, computed as n } from "vue";
function d(u, e) {
  return i(u, (r) => {
    r !== void 0 && (e.value = r);
  }), n(() => u.value === void 0 ? e.value : u.value);
}
export {
  d as default
};
